import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { DealerRiskReportRequest, DealerRiskReportResponseDto } from '../models/models'

export class GetDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/DealerRiskReport',
      requesterInfo,
    })
  }


  public async getDealerRiskReport(req: DealerRiskReportRequest): Promise<DealerRiskReportResponseDto> {
    return await this.postAsync<DealerRiskReportResponseDto>(req)
  }
}
